const getLanguageWithLocale = (locale) => (locale
  ? locale.replace(/-.+/, '') : 'en');

export default getLanguageWithLocale;
